import React, { useContext } from "react";
import { StaticSettingsAppContext } from "../../modules/App/App";
import { AppVariantType, APP_VARIANTS_ENUM } from "../../models/appSettings";
import { VariantFinishingGuide } from "./VariantFinishingGuide";
import { VariantCoreSelection } from "./VariantCoreSelection";
import { ProductItemProps } from "./model";

interface IProductVariantsView {
  variant: AppVariantType;
}

export const ProductItem = (props: ProductItemProps) => {
  const STATIC_SETTINGS_APP = useContext(StaticSettingsAppContext);

  const selectForInquiry = (variantId) => {
    if (typeof variantId === "number") {
      variantId = variantId.toString();
    }
    const indexOfSelected = props.dataForInquiry.findIndex(
      (val) => val === variantId
    );
    const _dataForInquiry = props.dataForInquiry.slice();

    if (indexOfSelected >= 0) {
      _dataForInquiry.splice(indexOfSelected, 1);
    } else {
      _dataForInquiry.push(variantId);
    }

    props.setDataForInquiry(_dataForInquiry);
  };
  const selectForComparison = (variantId) => {
    if (typeof variantId === "number") {
      variantId = variantId.toString();
    }
    const indexOfSelected = props.compareProductsSelected.findIndex(
      (val) => val === variantId
    );
    const _compareProductsSelected = props.compareProductsSelected.slice();
    if (indexOfSelected >= 0) {
      _compareProductsSelected.splice(indexOfSelected, 1);
    } else {
      _compareProductsSelected.push(variantId);
    }

    props.setCompareProductsSelected(_compareProductsSelected);
  };

  // Partials components of ProductItem
  const PropertiesIcons = () => {
    const icons = props.productData.TaxonomyIcons.map(
      (iconClass: string, index: number) => (
        <i
          className={`fas ${iconClass}`}
          key={`${props.productData.Id}-${index}`}
        ></i>
      )
    );

    return (
      <div className="properties">
        {props.productData.TaxonomyIcons.length > 0 && (
          <React.Fragment>
            <span>Properties</span>
            {icons}
          </React.Fragment>
        )}
      </div>
    );
  };

  const ImageBox = () => (
    <div className="image">
      <React.Fragment>
        {props.productData.ImageText && (
          <span>{props.productData.ImageText}</span>
        )}
        {props.productData.ImageSrc && (
          <img
            src={
              process.env.REACT_APP_PROXY_URL_ASSETS +
              props.productData.ImageSrc
            }
            alt={props.productData.ImageText}
          />
        )}
      </React.Fragment>
    </div>
  );

  const TextBox = () => (
    <div className="text">
      {props.productData.ProductUrl && props.productData.GroupName && (
        STATIC_SETTINGS_APP.APP_VARIANT == APP_VARIANTS_ENUM.FINISHING_GUIDE ?
        <h3>{props.productData.GroupName}</h3>
          :
        <a
          href={props.productData.ProductUrl}
          title={props.productData.GroupName}
        >
          <h3>{props.productData.GroupName}</h3>
        </a>
      )}
      {props.productData.Description && <p>{props.productData.Description}</p>}

      <PropertiesIcons />
    </div>
  );

  const ExtraInfoBox = () => (
    <div className="extra-information">
      {props.dictionary.ContactUsText && (
        <a
          href={props.dictionary.ContactUsUrl + "?" + props.productData.Id}
          title={props.dictionary.ContactUsText}
          className="button contact"
        >
          {props.dictionary.ContactUsText}
        </a>
      )}

      {props.productData.ApplicationAreasUrl &&
        props.productData.ApplicationAreasText && (
          <a
            href={props.productData.ApplicationAreasUrl}
            title={props.productData.ApplicationAreasText}
            className="button"
          >
            {props.productData.ApplicationAreasText}
          </a>
        )}

      {props.productData.KnowHowUrl && props.productData.KnowHowText && (
        <a
          href={props.productData.KnowHowUrl}
          title={props.productData.KnowHowText}
          className="button"
        >
          {props.productData.KnowHowText}
        </a>
      )}

      {props.productData.CasesUrl && props.productData.CasesText && (
        <a
          href={props.productData.CasesUrl}
          title={props.productData.CasesText}
          className="button"
        >
          {props.productData.CasesText}
        </a>
      )}
    </div>
  );

  const ProductVariantsView = ({ variant }: IProductVariantsView) => {
    switch (variant) {
      case APP_VARIANTS_ENUM.FINISHING_GUIDE:
        return (
          <VariantFinishingGuide
            selectForInquiry={selectForInquiry}
            selectForComparison={selectForComparison}
            {...props}
          />
        );
      case APP_VARIANTS_ENUM.CORE_SELECTION:
        return (
          <VariantCoreSelection
            selectForInquiry={selectForInquiry}
            selectForComparison={selectForComparison}
            {...props}
          />
        );
      default:
        return null;
    }
  };

  return (
    <div
      className={STATIC_SETTINGS_APP.CLASSES_NAMES.CLASS_ITEM}
      key={props.productData.Id}
    >
      <div className="into-row">
        <ImageBox />
        <TextBox />
        <ExtraInfoBox />
      </div>
      <ProductVariantsView variant={STATIC_SETTINGS_APP.APP_VARIANT} />
    </div>
  );
};
